'use client';

import { PrizeIcon } from '@repo/icons';
import { useDirection } from '@repo/react-hooks';
import { AmountText } from '@repo/ui/amount-text';
import { Avatar } from '@repo/ui/avatar';
import { Carousel, CarouselContent, CarouselItem } from '@repo/ui/carousel';
import { TabItem } from '@repo/ui/tab-item';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import userDemoImg from '@/assets/user-demo-icon.webp';
import getCasinoRecentBigWinsMockData from '@/mocks/CASINO_RECENT_BIG_WINS_MOCK_DATA';
import { useTenant } from '@/providers/TenantProvider';

const RecentBigWins = () => {
  const t = useTranslations('landing');
  const direction = useDirection();
  const tenant = useTenant();

  const CASINO_RECENT_BIG_WINS_MOCK_DATA = getCasinoRecentBigWinsMockData(tenant?.tenantMachineName);

  return (
    <div className="flex flex-col space-y-2 rounded">
      <label className="flex items-center gap-x-1">
        <PrizeIcon
          className="size-5"
          fill="#EFEFEF"
        />
        <h2 className="font-black vt-font-highlight-font-family vt-text-size-medium vt-headings-text sm:vt-text-size-big">
          {t('recent-big-wins')}
        </h2>
      </label>
      <Carousel
        className="flex overflow-x-hidden rounded-md py-2 vt-containers-recent-win-box-comp-bg"
        autoplay={true}
        autoplayDelay={0}
        opts={{
          direction,
          dragFree: true,
          loop: true,
          duration: 7000,
        }}
      >
        <CarouselContent className="w-full max-w-none">
          {CASINO_RECENT_BIG_WINS_MOCK_DATA?.map(({ user_name, user_id, amount, gameDetails }) => (
            <CarouselItem
              key={user_id}
              className="mr-[6px] basis-auto"
            >
              <TabItem
                variant="primary"
                orientation="horizontal"
                className="pointer-events-none !bg-transparent p-0"
              >
                <div className="flex flex-col items-start space-y-1 text-center">
                  <Image
                    src={gameDetails.img}
                    quality={100}
                    height={115}
                    width={100}
                    className="size-[90px] rounded-lg object-contain"
                    alt="recent big wins avatar"
                  />
                  <div className="flex w-full flex-col items-center justify-center">
                    <div className="flex w-full items-center justify-center space-x-1 rtl:space-x-reverse">
                      <Avatar
                        src={userDemoImg}
                        className="size-[17px]"
                      />
                      <div
                        dir="ltr"
                        className="max-w-[60px] text-center vt-font-highlight-font-family"
                      >
                        <span className="block truncate vt-text-size-small sm:vt-text-size-small-sm">{user_name}</span>
                      </div>
                    </div>

                    <div className="w-full vt-colors-accents-accent-1-600 vt-font-weight-bold">
                      <AmountText
                        value={amount}
                        currency="USD"
                        className="vt-text-size-small sm:vt-text-size-small-sm"
                      />
                    </div>
                  </div>
                </div>
              </TabItem>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
};

export default RecentBigWins;
